import { render, staticRenderFns } from "./vehicleCuringAction.vue?vue&type=template&id=2ee5a5fb&scoped=true"
import script from "./vehicleCuringAction.vue?vue&type=script&lang=js"
export * from "./vehicleCuringAction.vue?vue&type=script&lang=js"
import style0 from "./vehicleCuringAction.vue?vue&type=style&index=0&id=2ee5a5fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5a5fb",
  null
  
)

export default component.exports